// if (!customElements.get('image-hotspots')) {
//     class ImageHotspots extends HTMLElement {
//         constructor() {
//         super();
//         this.dots = this.querySelectorAll('.image-hotspots--pin');
//         this.desktopImage = this.querySelector('.image-hotspots--desktop');
//         this.mobileImage = this.querySelector('.image-hotspots--mobile');
//         this.image = window.innerWidth <= 767 && this.mobileImage ? this.mobileImage : this.desktopImage;

//         let resizeTimer;
//         window.addEventListener('resize', () => {
//             clearTimeout(resizeTimer);
//             resizeTimer = setTimeout(() => {
//               this.image = window.innerWidth <= 767 && this.mobileImage ? this.mobileImage : this.desktopImage;
//            }, 150);
//         });

//         this.dots.forEach((dot) => {
//             dot.addEventListener('click', (e) => {
//             e.stopPropagation();
//             this.togglePopup(dot);
//             });

//             const closeBtn = dot.querySelector('.hotspot--close');
//             if (closeBtn) {
//             closeBtn.addEventListener('click', (e) => {
//                 e.stopPropagation();
//                 this.resetZoom();
//                 dot.classList.remove('active');
//             });
//             }
//         });

//         document.addEventListener('click', (e) => {
//             if (!this.contains(e.target)) {
//             this.resetZoom();
//             this.dots.forEach((d) => d.classList.remove('active'));
//             }
//         });

//         // Overlay click closes
//         const overlay = document.querySelector('.hotspot-overlay');
//         if (overlay) {
//             overlay.addEventListener('click', () => {
//             this.resetZoom();
//             this.dots.forEach((d) => d.classList.remove('active'));
//             });
//         }
//         }

//         togglePopup(dot) {
//         this.dots.forEach((d) => {
//             if (d !== dot) d.classList.remove('active');
//         });

//         dot.classList.toggle('active');

//         if (dot.classList.contains('active')) {
//             this.applyZoom(dot);
//         } else {
//             this.resetZoom();
//         }
//         }

//         applyZoom(dot) {
//         if (!this.image || !dot) return;
//         const imgBounds = this.image.getBoundingClientRect();
//         const dotBounds = dot.getBoundingClientRect();

//         if (imgBounds.width > 0 && imgBounds.height > 0 && dotBounds.width > 0 && dotBounds.height > 0) {
//             const originX = ((dotBounds.left + dotBounds.width / 2 - imgBounds.left) / imgBounds.width) * 100;
//             const originY = ((dotBounds.top + dotBounds.height / 2 - imgBounds.top) / imgBounds.height) * 100;
//               // Clamp values to prevent invalid CSS
//            const clampedX = Math.max(0, Math.min(100, originX));
//            const clampedY = Math.max(0, Math.min(100, originY));
//            this.image.style.setProperty('--zoom-origin-x', `${clampedX}%`);
//            this.image.style.setProperty('--zoom-origin-y', `${clampedY}%`);
//            this.image.classList.add('zoomed');
//         }
//         }

//         resetZoom() {
//         if (this.image) {
//             this.image.classList.remove('zoomed');
//             this.image.style.removeProperty('--zoom-origin-x');
//             this.image.style.removeProperty('--zoom-origin-y');
//         }
//         }
//     }

//     customElements.define('image-hotspots', ImageHotspots);
// }  

if (!customElements.get('image-hotspots')) {
    class ImageHotspots extends HTMLElement {
      constructor() {
        super();
        this.dots = this.querySelectorAll('.image-hotspots--pin');
        this.desktopImage = this.querySelector('.image-hotspots--desktop');
        this.mobileImage = this.querySelector('.image-hotspots--mobile');
        this.image = window.innerWidth <= 767 && this.mobileImage ? this.mobileImage : this.desktopImage;
  
        let resizeTimer;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            this.image = window.innerWidth <= 767 && this.mobileImage ? this.mobileImage : this.desktopImage;
          }, 150);
        });
  
        this.dots.forEach((dot) => {
          dot.addEventListener('click', (e) => {
            e.stopPropagation();
            this.togglePopup(dot);
          });
  
          const closeBtn = dot.querySelector('.hotspot--close');
          if (closeBtn) {
            closeBtn.addEventListener('click', (e) => {
              e.stopPropagation();
              this.closeAll();
            });
          }
        });
  
        document.addEventListener('click', (e) => {
          if (!this.contains(e.target)) {
            this.closeAll();
          }
        });
  
        // Overlay click closes
        const overlay = document.querySelector('.hotspot-overlay');
        if (overlay) {
          overlay.addEventListener('click', () => {
            this.closeAll();
          });
        }
      }
  
      togglePopup(dot) {
        this.dots.forEach((d) => {
          if (d !== dot) d.classList.remove('active');
        });
  
        dot.classList.toggle('active');
  
        if (dot.classList.contains('active')) {
          this.applyZoom(dot);
          this.lockScroll();
        } else {
          this.resetZoom();
          this.unlockScroll();
        }
      }
  
      applyZoom(dot) {
        if (!this.image || !dot) return;
        const imgBounds = this.image.getBoundingClientRect();
        const dotBounds = dot.getBoundingClientRect();
  
        if (imgBounds.width > 0 && imgBounds.height > 0 && dotBounds.width > 0 && dotBounds.height > 0) {
          const originX = ((dotBounds.left + dotBounds.width / 2 - imgBounds.left) / imgBounds.width) * 100;
          const originY = ((dotBounds.top + dotBounds.height / 2 - imgBounds.top) / imgBounds.height) * 100;
          const clampedX = Math.max(0, Math.min(100, originX));
          const clampedY = Math.max(0, Math.min(100, originY));
          this.image.style.setProperty('--zoom-origin-x', `${clampedX}%`);
          this.image.style.setProperty('--zoom-origin-y', `${clampedY}%`);
          this.image.classList.add('zoomed');
        }
      }
  
      resetZoom() {
        if (this.image) {
          this.image.classList.remove('zoomed');
          this.image.style.removeProperty('--zoom-origin-x');
          this.image.style.removeProperty('--zoom-origin-y');
        }
      }
  
      closeAll() {
        this.resetZoom();
        this.dots.forEach((d) => d.classList.remove('active'));
        this.unlockScroll();
      }
  
      lockScroll() {
        if (window.innerWidth <= 767) { // ✅ Only mobile
          document.body.style.overflow = 'hidden';
          document.body.style.touchAction = 'none';
        }
      }
  
      unlockScroll() {
        if (window.innerWidth <= 767) { // ✅ Only mobile
          document.body.style.overflow = '';
          document.body.style.touchAction = '';
        }
      }
    }
  
    customElements.define('image-hotspots', ImageHotspots);
}